import {BaseModel} from '../base';
import {Utils} from '../../utils/utils';

/**
 * @description
 * A class that defines a basket as a collection of items.
 *
 */
class MultiBasketModel extends BaseModel {
    constructor(data, scope) {
        super(data);

        if (data) {
            if (data.company_id) {
                this.company_id = data.company_id;
            }

            this.items = [];
        }

    }

    setCompany(company) {
        this.company = company;
    }

    setClient(client) {
        this.client = client;
    }

    addItems(items) {
        this.items.push(items);
        this.items = Utils.flatten(this.items);
    }

    /**
     * @description
     * Use to check if the basket is ready to checkout - and has been reviews
     *
     * @returns {boolean} Flag to indicate if basket is ready checkout
     */
    readyToCheckout() {
        return ((this.items.length > 0 ) && this.reviewed);
    }


    /**
     * @description
     * Build an array with details for every item in items array
     *
     * @returns {array} newly created details array
     */
    getPostData() {
        const postData = {
            client: this.client.getPostData(),
            settings: this.settings,
            reference: this.reference
        };
        postData.is_admin = this.is_admin;
        postData.parent_client_id = this.parent_client_id;
        postData.take_from_wallet = this.take_from_wallet;
        return postData;
    }
}

export {
    MultiBasketModel
};
